import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Col,
  Input,
  Typography,
  Button,
  Modal,
  Space,
  Row,
  message,
  Select,
  Spin,
} from "antd";
// import { EditTwoTone } from "@ant-design/icons";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { getUsers, updateUser } from "../Actions/usersAction";
import "./styles/clients.css";
const Role = [
  { value: "Admin", label: "Admin" },
  { value: "Employee", label: "Employee" },
];
// const phoneRegExp = /^[0][1-9]\d{9}$|^[1-9]\d{9}$/;
const schema = Yup.object().shape({
  first_name: Yup.string().required("Required"),
  last_name: Yup.string().required("Required"),
  email: Yup.string().email().required("Required"),
  role: Yup.string().optional(),
});
const { Text } = Typography;
export const UpdateEmployeeUser = ({ id, setPopoverVisible }) => {
  const dispatch = useDispatch();
  const { users, currentUser, isUpdateUserLoading } = useSelector(
    (state) => state.users
  );
  const the_user = users.filter((client) => client.id === id);
  const isSelf = currentUser?.id === id;
  const [open, setOpen] = useState(false);
  const { handleSubmit, errors, control, reset } = useForm({
    resolver: yupResolver(schema),
    defaultValues: the_user[0],
  });

  useEffect(() => {
    if (open && the_user[0]) {
      reset(the_user[0]);
    }
  }, [open, the_user[0], reset]);
  // const handleUpdateUser = (data, event) => {
  //   event.preventDefault();
  //   data.id = id;
  //   dispatch(updateUser(data));
  //   setOpen(false);
  //   reset(data)
  // };
  const handleUpdateUser = (data, event) => {
    data.id = id;
    // event.preventDefault();
    dispatch(updateUser(data, successUpdateUser, failureUpdateUser));
  };
  const successUpdateUser = () => {
    setOpen(false);
    dispatch(getUsers());
    reset();
    setTimeout(() => {
      message.success("You have successfully update user.");
    }, 2000);
  };
  const failureUpdateUser = () => {
    setTimeout(() => {
      message.info("Something went wrong.");
    }, 2000);
    reset();
  };
  const handleOpenEmployeeuser = () => {
    setPopoverVisible(false);
    setOpen(true);
  };
  return (
    <>
      <Button
        type="link"
        style={{ cursor: "pointer" }}
        onClick={() => handleOpenEmployeeuser()}
      >
        Edit
      </Button>
      <Modal
        title="Edit User details"
        visible={open}
        onCancel={() => setOpen(false)}
        footer={null}
        maskClosable={false}
      >
        <Spin spinning={isUpdateUserLoading}>
          <form onSubmit={handleSubmit(handleUpdateUser)}>
            <Row>
              <Col xl={12} lg={12} md={12} sm={24} xs={24}>
                <Space direction="vertical" className="create_client_field">
                  <Text>First Name</Text>
                  <Controller
                    as={Input}
                    name="first_name"
                    control={control}
                    placeholder="First Name"
                    style={{ width: 200 }}
                  />
                  {errors.first_name && (
                    <span className="error_style">First Name is required</span>
                  )}
                </Space>
              </Col>
              <Col xl={12} lg={12} md={12} sm={24} xs={24}>
                <Space direction="vertical" className="create_client_field">
                  <Text>Last Name</Text>
                  <Controller
                    as={Input}
                    name="last_name"
                    control={control}
                    placeholder="Last Name"
                    style={{ width: 200 }}
                  />
                  {errors.last_name && (
                    <span className="error_style">Last Name is required</span>
                  )}
                </Space>
              </Col>
            </Row>
            <Row>
              <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                <Space direction="vertical" className="create_client_field">
                  <Text>E-mail</Text>
                  <Controller
                    as={Input}
                    name="email"
                    control={control}
                    placeholder="E-mail"
                    style={{ width: 200 }}
                    disabled={true}
                  />
                  {errors.email && (
                    <span className="error_style">E-mail is required</span>
                  )}
                </Space>
              </Col>
            </Row>
            {currentUser?.role === "Admin" && (
              <Space direction="vertical" className="create_client_field">
                <Text>Role Type</Text>
                <Controller
                  as={Select}
                  control={control}
                  options={Role}
                  style={{ width: 200 }}
                  name="role"
                  disabled={isSelf}
                />
                {errors.role && (
                  <span className="error_style">Role Type is required</span>
                )}
              </Space>
            )}

            <Col className="notes_box">
              <Button type="primary" htmlType="submit" block style={{ top: 10 }}>
                Update
              </Button>
            </Col>
          </form>
        </Spin>
      </Modal>
    </>
  );
};
